import httpService from '@/services/core/http.service';

class IntegrationsService {
    route = 'integrations';

    sensors = () => httpService.get(`${this.route}/sensors`);
    sensorMapping = sensorId => httpService.get(`${this.route}/sensors/${sensorId}/mapping`);
    history = levelconId =>
        httpService.get(`${this.route}/emulator/history`, levelconId ? { levelconId } : undefined);
    postHistory = body => httpService.post(`${this.route}/emulator/history`, body);
    deleteHistory = id => httpService.delete(`${this.route}/emulator/history/${id}`);
    hourlyStream = params => httpService.get(`${this.route}/emulator/hourly-stream`, params);
    putHourlyStream = body => httpService.put(`${this.route}/emulator/hourly-stream`, body);
}

export default new IntegrationsService();
